import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CustomerAwards.css";
import img1 from "../assets/award-img1.jpg";
import img2 from "../assets/IGBC Green Building – Platinum Rating Award.jpg";
import img3 from "../assets/award-img3.jpg";
import img4 from "../assets/award-img2.jpg";
import imgarrl from "../assets/arrow-left.png";
import imgarrr from "../assets/arrow-right.png";

const awards = [
  { img: img2, alt: "IGBC Green Building – Platinum Rating Award", caption: "2026 - IGBC Green Building – Platinum Rating Award" },
  { img: img1, alt: "Q-Prime Gold Award - DICV", caption: "2026 - Q-Prime Gold Award - DICV" },
  { img: img4, alt: "Supplier of the Year – Quality Award – Hyundai", caption: "2026 - Supplier of the Year – Quality Award – Hyundai" },
  { img: img3, alt: "Quality Excellence Award - Kia", caption: "2025 - Quality Excellence Award - Kia" },
  
];

const CustomerAwards = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const navigate = useNavigate();

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? awards.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === awards.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="awards-section">
      <div className="awards-left">
        <h2>Awards & Recognitions</h2>
        <div className="awards-underline"></div>
        <p className="awards-tagline">
          Awards That Reflect Trust, Quality, and Partnership
        </p>
        
        
        <button
          className="cus-btn"
          onClick={() => navigate("/awards")} id="awards"
        >
          Know More
        </button>
        <div className="awards-controls">
          <button onClick={prevSlide} className="arrow-btn">
            <img src={imgarrl} alt="icon" />
          </button>
          <button onClick={nextSlide} className="arrow-btn">
            <img src={imgarrr} alt="icon" />
          </button>
        </div>
      </div>

      <div className="awards-carousel">
        <div
          className="awards-slider"
          style={{ transform: `translateX(-${currentIndex * 320}px)` }}
        >
          {awards.map((award, index) => (
            <div
              className={`award-card ${index === currentIndex ? "active" : "inactive"
                }`}
              key={index}
            >
              <img src={award.img} alt={award.alt} />
              <p className="award-caption">{award.caption}</p>
            </div>
          ))}
        </div>

        {/*Slider Dots Section */}
        <div className="awards-dots">
          {awards.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentIndex ? "active-dot" : ""}`}
              onClick={() => setCurrentIndex(index)}
            ></span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CustomerAwards;
